import DialogGuidance from './dialog-guidance';

export default DialogGuidance;